export const typeConfig = {
  option: {},
  load: false,
  clear: false,
};
export const originConfig = {
  option: {},
  load: false,
  clear: false,
};
export const rationalityConfig = {
  option: {},
  load: false,
  clear: false,
};

export const nameEnToZh = new Map([
  ['skill_lack_rate', '作业技能不足'],
  ['job_dispatch_rate', '任务调度相关占比'],
  ['vacation_rate', '假期占比'],
  ['platform_rate', '平台占比'],
  ['train_exam_rate', '培训/考试占比'],
  ['outsourcer_rate', '外包商占比'],
  ['inside_rate', '内部占比'],
  ['unrational_rate', '不合理占比'],
  ['rational_rate', '合理占比'],
]);
